import { AboutMe, Education, Feedback, Qualifications, WorkExperience } from "swing-components";

import { translate, useIsDesktop } from "~utils";

import { Contact } from "./Contact";
import { SubDetails } from "./SubDetails";
import { SubProfileProps } from "./types";

export function SubProfile(props: SubProfileProps) {
  const {
    name,
    about,
    education,
    experience,
    feedback,
    qualifications,
    qualificationsDetails,
    email,
    phoneNumber,
    profileImageUrl: photo,
    stats,
    districtDaysWorked,
    languages,
    isDistrictFavorited,
    hasSpedExperience,
    completedSkillBuilders,
    isReferenceVerified,
  } = props;
  const { daysWorked, timesPreferred, positiveReviews, isSwingHero } = stats || {};
  const isDesktop = useIsDesktop();

  const subDetails = {
    name,
    photo,
    daysWorked,
    districtDaysWorked,
    timesPreferred,
    positiveReviews,
    languages,
    isDistrictFavorited,
    hasSpedExperience,
    isSwingHero,
    isReferenceVerified,
  };

  const contactAndQualifications = {
    email,
    phoneNumber,
    qualifications,
    qualificationsDetails,
    completedSkillBuilders,
    isSwingHero,
  };

  return (
    <div
      css={{
        display: "flex",
        gap: "var(--spacing-2xl)",
      }}
    >
      <div
        css={{
          flex: 1,
          display: "flex",
          gap: "var(--spacing-2xl)",
          flexDirection: "column",
          padding: "0 var(--spacing-sm)",
        }}
      >
        <SubDetails {...subDetails} />
        {!isDesktop && <ContactAndQualifications {...contactAndQualifications} />}
        <AboutMe about={about} title={translate("SUB_PROFILE_ABOUT_TITLE", { subName: name })} />
        <Education
          education={education?.map((edu: string, idx: number) => ({
            // mapping here is required for compat with swing-components
            name: edu,
            id: idx,
          }))}
        />
        <WorkExperience experiences={experience}></WorkExperience>
        <Feedback feedbacks={feedback}></Feedback>
      </div>
      {isDesktop && <ContactAndQualifications {...contactAndQualifications} />}
    </div>
  );
}

type ContactAndQualificationsProps = {
  email: string;
  phoneNumber: string;
  qualifications: string[];
  qualificationsDetails?: Array<{ name: string; subjects: string[] }>;
  completedSkillBuilders?: string[];
  isSwingHero: boolean;
};

function ContactAndQualifications(props: ContactAndQualificationsProps) {
  const { email, phoneNumber, ...rest } = props;

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--spacing-2xl)",
        maxWidth: 350,
      }}
    >
      <Contact email={email} phone={phoneNumber}></Contact>
      <Qualifications {...rest} />
    </div>
  );
}
